module.exports = __webpack_public_path__ + "static/raw-6-e15f4bbcf7da8b04e0c4c1d292a71bfc.jpg";